module.exports = "<ng-template #content></ng-template>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/plugins/templates/empty/empty.component.html
// module id = ./libs/chassis-core/src/app/plugins/templates/empty/empty.component.html
// module chunks = main